
// used for all custom reducers, the string will help us have a brief description of what the action does
// in the redux extension debugger
export const types = {
    login: '[auth] Login',
    logout: '[auth] Logout',

    uiSetError: '[UI] set error',
    uiRemoveError: '[UI] remove error',

    englishLanguage: '[UI] start English language',
    spanishLanguage: '[UI] start Spanish language'
}
